const ENV_PREFIX = process.env.NEXT_PUBLIC_ENV_STAGE ?? 'development'

export function getStorageKey(key: string): string {
  return `${ENV_PREFIX}:${key}`
}

export function setLocalStorage(key: string, value: string) {
  return localStorage.setItem(getStorageKey(key), value)
}

export function getLocalStorage(key: string): any {
  return localStorage.getItem(getStorageKey(key))
}

export function deleteLocalStorage(key: string) {
  return localStorage.removeItem(getStorageKey(key))
}

export function checkLocalStorage(key: string) {
  return getStorageKey(key) in localStorage
}
